import { Component, OnInit, Input } from '@angular/core';

@Component({
  selector: 'app-mcommerce-trip-detail-cart-card',
  templateUrl: './mcommerce-trip-detail-cart-card.component.html',
  styleUrls: ['./mcommerce-trip-detail-cart-card.component.scss']
})
export class McommerceTripDetailCartCardComponent implements OnInit {

  @Input() data;

  constructor() { }

  ngOnInit() {
  }

}
